:host {
  display: block;
  overflow: hidden;
}

.calendar-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 0 10px;
}

@media screen and (min-width: 500px) {
  .calendar-cards {
    display: grid;
    grid-template-columns: repeat( auto-fill, minmax( 320px, 1fr ) );
  }
}

.calendar-card {
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  width: 100%;
}

.calendar-card[hidden] {
  display: none;
}

